import DeleteForeverRounded from '@glass/web/components/base/icons/DeleteForeverRounded';
import EditRounded from '@glass/web/components/base/icons/EditRounded';
import FileCopyRounded from '@glass/web/components/base/icons/FileCopyRounded';

export const EDIT_CARD_ACTION = 'edit';
export const DELETE_CARD_ACTION = 'delete';
export const DUPLICATE_CARD_ACTION = 'duplicate';

const cardActions = [
  {
    key: EDIT_CARD_ACTION,
    Icon: EditRounded,
  },
  {
    key: DUPLICATE_CARD_ACTION,
    Icon: FileCopyRounded,
  },
  {
    key: DELETE_CARD_ACTION,
    Icon: DeleteForeverRounded,
  },
];

export default cardActions;
